import i18next from 'i18next';
/*import en from '../../resources/en.json';
import cs from '../../resources/cs.json';
import de from '../../resources/de.json';
import es from '../../resources/es.json';
import fr from '../../resources/fr.json';
import hu from '../../resources/hu.json';
import it from '../../resources/it.json';
import ko from '../../resources/ko.json';
import nl from '../../resources/nl.json';
import pl from '../../resources/pl.json';
import pt_BR from '../../resources/pt_BR.json';
import ru from '../../resources/ru.json';
import sv from '../../resources/sv.json';
import zh_CN from '../../resources/zh_CN.json';
import zh_TW from '../../resources/zh_TW.json';
import ja from '../../resources/ja.json';
import no from '../../resources/no.json';
import da from '../../resources/da.json';
import el from '../../resources/el.json';
import fi from '../../resources/fi.json';
import hr from '../../resources/hr.json';
import tr from '../../resources/tr.json';
import sk from '../../resources/sk.json';
import ro from '../../resources/ro.json';
import bg from '../../resources/bg.json';
import sl from '../../resources/sl.json';*/

i18next.init({
  interpolation: {
    escapeValue: false
  },
  lng: navigator.language || navigator.browserLanguage,
  fallbackLng: 'en',
  resources: {
    en: {
      translation: window.en
    },
    cs: {
      translation: window.cs
    },
    de: {
      translation: window.de
    },
    es: {
      translation: window.es
    },
    fr: {
      translation: window.fr
    },
    hu: {
      translation: window.hu
    },
    it: {
      translation: window.it
    },
    ko: {
      translation: window.ko
    },
    nl: {
      translation: window.nl
    },
    pl: {
      translation: window.pl
    },
    'pt-BR': {
      translation: window.pt
    },
    pt_BR: {
      translation: window.pt
    },
    pt: {
      translation: window.pt
    },
    ru: {
      translation: window.ru
    },
    sv: {
      translation: window.sv
    },
    'zh-CN': {
      translation: window.zh_CN
    },
    zh_CN: {
      translation: window.zh_CN
    },
    'zh-TW': {
      translation: window.zh_TW
    },
    zh_TW: {
      translation: window.zh_TW
    },
    ja: {
      translation: window.ja
    },
    no: {
      translation: window.no
    },
    da: {
      translation: window.da
    },
    el: {
      translation: window.el
    },
    fi: {
      translation: window.fi
    },
    hr: {
      translation: window.hr
    },
    tr: {
      translation: window.tr
    },
    sk: {
      translation: window.sk
    },
    ro: {
      translation: window.ro
    },
    bg: {
      translation: window.bg
    },
    sl: {
      translation: window.sl
    }
  }
});

export default i18next;



// WEBPACK FOOTER //
// ./src/components/i18next/i18next.js